import { type IconType } from ".";

const CalendarIcon: IconType = (props) => {
  const fill = props.fill ?? "fill-none";
  const stroke = props.stroke ?? "stroke-white";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      viewBox="0 0 26 26"
      width={25}
      height={25}
      className={`${props.size}`}
      {...props}
    >
      <defs>
        <style>
          {
            ".cls-1{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"
          }
        </style>
      </defs>
      <g id="Interface-Essential__x2F__Date_x2F_Calendar__x2F__calendar-add-1">
        <g id="Group_267">
          <g id="calendar-add-1">
            <path
              id="Shape_1218"
              d="M9.25 18.25h-6c-.83 0-1.5-.67-1.5-1.5v-12c0-.83.67-1.5 1.5-1.5h13.5c.83 0 1.5.67 1.5 1.5v4.5"
              className={`cls-1 ${fill} ${stroke}`}
            />
            <path
              id="Shape_1219"
              d="M1.75 7.75h16.5"
              className={`cls-1 ${fill} ${stroke}`}
            />
            <path
              id="Shape_1220"
              d="M6.25 4.75v-3"
              className={`cls-1 ${fill} ${stroke}`}
            />
            <path
              id="Shape_1221"
              d="M13.75 4.75v-3"
              className={`cls-1 ${fill} ${stroke}`}
            />
            <path
              id="Oval_168"
              d="M18.25 24.25c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6Z"
              className={`cls-1 ${fill} ${stroke}`}
            />
            <path
              id="Shape_1222"
              d="M18.25 15.25v6"
              className={`cls-1 ${fill} ${stroke}`}
            />
            <path
              id="Shape_1223"
              d="M15.25 18.25h6"
              className={`cls-1 ${fill} ${stroke}`}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default CalendarIcon;
